<p-card class="w-full">
	<app-support-request-form [showCancelButton]="false" (submitted)="onFormSubmitted()"></app-support-request-form>
</p-card>
